export const ticketType = {
    virtualUser: {
        activateAccount: {
            value: "ActivateAccount",
            id: 0
        },
        setEmail: {
            value: "SetEmail",
            id: 1
        },
        resetPassword: {
            value: "ResetPassword",
            id: 2
        },
    },
    user: {
        resetPassword:  {
            value: "ResetPassword",
            id: 0
        },
        upgradeToVirtualUser:  {
            value: "UpgradeToVirtualUser",
            id: 1
        }
    }
};

export default ticketType;
